import { Grid, GridItem, Image } from "@chakra-ui/react";
import { Card } from "components/stats/Card";

export const IntegrationShowcase = () => {
  const intLogos = [
    "https://images-lead-pro.s3.eu-west-2.amazonaws.com/integration-logo/reapit.jpeg",
    "https://images-lead-pro.s3.eu-west-2.amazonaws.com/integration-logo/alto.jpeg",
    "https://images-lead-pro.s3.eu-west-2.amazonaws.com/integration-logo/rex.png",
    "https://images-lead-pro.s3.eu-west-2.amazonaws.com/integration-logo/street.png",
    "https://images-lead-pro.s3.eu-west-2.amazonaws.com/integration-logo/iamproperty-crm.png",
    "https://images-lead-pro.s3.eu-west-2.amazonaws.com/integration-logo/mri.png",
  ];

  return (
    <Grid templateColumns={"repeat(3, 1fr)"} gap={4}>
      {intLogos.map(logo => (
        <GridItem>
          <Card padding={4}>
            <Image
              src={logo}
              height={"62px"}
              width={"62px"}
              rounded={"md"}
              objectFit={"contain"}
            />
          </Card>
        </GridItem>
      ))}
    </Grid>
  );
};
